<template>
    <div>
      <a-spin :spinning="loading" tip="در حال دریافت اطلاعات">
        <div class="spin-content">
          <a-card>
            <a-button @click="$router.push('/register/users')" :disabled="!$getAccess('user.create')">
              ثبت کاربر جدید
            </a-button>
            <x-table ref="users" class="mt-4"
                     :model="cols">
              <template slot="operator" slot-scope="text,record">
                <a-button type="primary" class="ml-2" @click="showUser(text.record)"  :disabled="!$getAccess('user.update')">ویرایش</a-button>
                <a-popconfirm
                    title="از حذف کاربر مطمعن هستید؟"
                    ok-text="بله"
                    cancel-text="خیر"
                    @confirm= "removeUsre(text.record)"
                    @cancel=""
                >
                  <a-button type="danger" :disabled="!$getAccess('user.delete')">حذف</a-button>
                </a-popconfirm>
              </template>
            </x-table>
            <a-modal  @ok="handleSubmit" :forceRender="false" okText="ویرایش" cancelText="بستن" width="90%" v-model="model" title="ویرایش اطلاعات کاربر">
              <a-form :form="form"  @submit="handleSubmit">
                <a-spin :spinning="loading" tip="در حال دریافت اطلاعات">
                  <div class="grid grid-col-1 sm:grid-cols-1 md:grid-cols-2 md:gap-2 lg:gap-4 xl:gap-4">
                  <a-form-item label="نام" has-feedback>
                    <a-input
                        v-decorator="['fname', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' },{ pattern:/^([\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C ])+$/,type:'string',message:'فیلد نام باید شامل حروف فارسی باشد.' }] }]"
                        autocomplete="off"
                    />

                  </a-form-item>
                  <a-form-item label="نام خانوادگی" has-feedback>
                    <a-input
                        v-decorator="['lname', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' },{ pattern:/^([\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C ])+$/,type:'string',message:'فیلد نام باید شامل حروف فارسی باشد.' }] }]"
                        autocomplete="off"
                    />
                  </a-form-item>
                  <a-form-item label="شماره موبایل" has-feedback>
                    <a-input
                        v-decorator="['mobile', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' },{pattern:/^(\+98|0098|98|0)?9\d{9}$/g,message:'فرمت شماره موبایل نادرست است.'},{ min:11,required: true, message: 'شماره موبایل باید 11 رقم باشد '}] }]"
                        placeholder="09XXXXXXXXX"
                    />
                  </a-form-item>
                  <a-form-item label="نوع کاربری" has-feedback>
                    <a-select
                        show-search
                        allowClear
                        placeholder="انتخاب کنید"
                        v-decorator="['user_type',{ rules: [{ required: true, message: 'وارد کردن مقدار الزامی است' }] }]"
                    >
                      <a-select-option v-for="item in userTypes" :value="item.id">
                        {{item.value}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="رمز عبور" has-feedback>
                    <a-input-password placeholder="رمز عبور خود را وارد کنید"
                                      :autocomplete="false"
                                      v-decorator="['password', { rules: [
              { required: false, message: 'لطفا مقدار را وارد کنید' },
              {min: 6, message: 'رمز عبور نباید کمتر از 6 کارکتر باشد' },
              {max: 24, message: 'رمز عبور نباید بیشتر از 24 کارکتر باشد' },
              ]}]"
                    />
                  </a-form-item>
                  <a-form-item label="وضعیت">
                    <a-switch checked-children="فعال" un-checked-children="غیر فعال" default-checked
                              v-decorator="['active', { valuePropName: 'checked' }]"/>
                  </a-form-item>

                </div>
                </a-spin>
              </a-form>
            </a-modal>

          </a-card>
        </div>
      </a-spin>
    </div>

</template>

<script>

    import tbl from './usersTbl';
    import XTable from "@/components/new-x-table/XTable";
    import axios from "@/axios";


    export default {
        components:{
          XTable,
        },
        data() {
            return {
              cols : null,
              form: this.$form.createForm(this, { name: 'coordinated' }),
              loading: false,
              userTypes:{},
              record : undefined,
              id : undefined,
              model : false
            }
        },
        methods:{
          async handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields(async(err, values) => {
              if (!err) {
                try{
                  this.$vs.loading()
                  this.loading = true
                  values.op = "update"
                  await axios.put(`/user/${this.id}`,values)
                  this.model = false
                  this.$ntSet()
                  this.$refs.users.fetch()
                }catch (e) {
                  if(e.response.data.errors){
                    let str_error = ''
                    for (let x of Object.values(e.response.data.errors)){
                      x.map(xx=>{
                        str_error += xx + "<br/>"
                      })
                    }
                    this.$ntSetError(str_error)
                  }
                }finally {
                  this.loading = false
                  this.$vs.loading.close()
                }
              }

            });
          },
          async showUser(record) {
            try {
              this.loading =true
              this.model = true
              console.log(record)
              let {data} = await axios.get(`/user/${record.id}`)
              if(data.user_type && data.user_type.id)
                data.user_type = data.user_type.id
              else
                data.user_type = undefined
              if(!data.fname && !data.lname && data.name){
                let splited = data.name.split(" ")
                data.fname =splited[0]
                data.lname =splited.slice(1).join(" ")
              }
              this.record = data
              this.id = record.id
              this.form.setFieldsValue(data)
            }catch (e) {
                throw e
            }
            finally {
              this.loading = false
            }
          },
          async removeUsre(record) {
                try {
                  this.loading = true
                  console.log(record)
                  // await axios.delete(`/user/${record.id}`)
                  this.$refs.users.fetch()
                }catch (e) {
                  if(e.response.data.errors){
                    let str_error = ''
                    for (let x of Object.values(e.response.data.errors)){
                      x.map(xx=>{
                        str_error += xx + "<br/>"
                      })
                    }
                    this.$ntSetError(str_error)
                  }
                }finally {
                  this.loading = false
                }
            },
        },
        async created() {
            try{
              this.cols = tbl;
              this.loading = true
              const { data } = await axios.get(`/permission/type`)
              this.userTypes = data
            }catch (e) {
              this.$ntSetError('خطا در دریافت اطلاعات')
            }finally {
              this.loading = false
            }
        }
    }
</script>

<!--
<style>
    .ant-pagination
    {
        direction: ltr !important;
    }
    td,th{
        text-align: right !important;
    }
    .ant-tabs-nav-wrap
    {
        float: right !important;
    }
    .ant-tabs-content
    {
        text-align: right !important;
    }
    .ant-modal-mask
    {
        z-index: 9999999 !important;
    }
    .ant-modal-wrap
    {
        z-index: 999999999 !important;
    }
    .ant-select-dropdown{
        z-index: 999999999!important;
    }
    .ant-modal-content
    {
        direction: ltr !important;
    }
    .ant-modal-body
    {
        direction: rtl !important;
    }
    .ant-modal-header
    {
        direction: rtl;
        margin-right: 25px;
    }
    .ant-dropdown,.ant-popover.ant-popover-placement-right{
        z-index: 99999999999;
    }
    /*.ant-dropdown
    {
      z-index: 9999999999 !important;
    }*/
    .ant-form-item-label
    {
        direction: rtl !important;
    }
    .ant-list-item
    {
        direction: ltr;
    }
    .ant-upload.ant-upload-select-picture-card,.ant-upload-list-picture-card-container{
      float: right !important;
    }
    .ant-upload-list-item-card-actions  {
      right:80% !important;
    }
   /* .ant-dropdown,.ant-popover.ant-popover-placement-right{
      z-index: 999999999;
    }*/
</style>-->

